(function(){

	var Stone = function(mc_name, name, properties, excludes)
	{
		this.mc_name = mc_name;
		this.name = name;

		if (properties) {
			this.properties = properties;
		} else {
			this.properties = {};
		}
		
		if (excludes) {
			this.excludes = excludes;
		} else {
			this.excludes = {};
		}
	};

	// Reference to the prototype
	var p = Stone.prototype;

	p.TYPE_STONE = 'stone';
	p.TYPE_CRYSTAL = 'crystal';
	p.TYPE_OBJECT = 'object';
	
	p.SHAPE_ROUND = 'round';
	p.SHAPE_SHARP = 'sharp';
	
	p.COLOR_YELLOW = 'yellow';
	p.COLOR_RED = 'red';
	p.COLOR_BLUE = 'blue';
	p.COLOR_GREEN = 'green';
	p.COLOR_WHITE = 'white';
	p.COLOR_PURPLE = 'purple';

	p.COLORS = [p.COLOR_YELLOW,p.COLOR_RED,p.COLOR_BLUE,p.COLOR_GREEN,p.COLOR_WHITE,p.COLOR_PURPLE];


	p.STONES = [
			{
				'name': 'Agate',
				'mc_name': 'stone_agate_{0}',
				'size': 2,
				'type': p.TYPE_STONE,
				'shape': p.SHAPE_ROUND
			},
			{
				'name': 'Red jasper',
				'mc_name': 'stone_jasper_{0}',
				'size': 3,
				'type': p.TYPE_CRYSTAL,
				'shape': p.SHAPE_SHARP
			},
			{
				'name': 'Turquoise',
				'mc_name': 'stone_turquoise_{0}',
				'size': 3,
				'type': p.TYPE_STONE,
				'shape': p.SHAPE_ROUND
			},
			{
				'name': 'Obsidian',
				'mc_name': 'stone_obsidian_{0}',
				'size': 5,
				'type': p.TYPE_STONE,
				'shape': p.SHAPE_ROUND
			},
			{
				'name': 'Amethyst',
				'mc_name': 'stone_amethyst_{0}',
				'size': 4,
				'type': p.TYPE_CRYSTAL,
				'shape': p.SHAPE_SHARP
			},
			{
				'name': 'White quartz',
				'mc_name': 'stone_quartz_{0}',
				'size': 6,
				'type': p.TYPE_CRYSTAL,
				'shape': p.SHAPE_SHARP
			}
		];

		p.copy = function(){

			var _stone = new Stone(
				this.mc_name,
				this.name
			);
			
			for (var properties_key in this.properties)
			{
				_stone.properties[properties_key] = this.properties[properties_key];
			}
			
			for (var excludes_key in this.excludes)
			{			
				_stone.excludes[properties_key] = this.properties[properties_key];
			}
			
			_stone.movieClip = this.movieClip;
			
			return _stone;
		};
	
	// Assign to namespace
	namespace('sortingBox').Stone = Stone;

}());	
